/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardResponseObject } from './RewardResponseObject';
import {
    RewardResponseObjectFromJSON,
    RewardResponseObjectFromJSONTyped,
    RewardResponseObjectToJSON,
    RewardResponseObjectToJSONTyped,
} from './RewardResponseObject';

/**
 * 
 * @export
 * @interface ClaimQuestRewardResponse
 */
export interface ClaimQuestRewardResponse {
    /**
     * 
     * @type {Array<RewardResponseObject>}
     * @memberof ClaimQuestRewardResponse
     */
    rewards: Array<RewardResponseObject>;
}

/**
 * Check if a given object implements the ClaimQuestRewardResponse interface.
 */
export function instanceOfClaimQuestRewardResponse(value: object): value is ClaimQuestRewardResponse {
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    return true;
}

export function ClaimQuestRewardResponseFromJSON(json: any): ClaimQuestRewardResponse {
    return ClaimQuestRewardResponseFromJSONTyped(json, false);
}

export function ClaimQuestRewardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimQuestRewardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rewards': ((json['rewards'] as Array<any>).map(RewardResponseObjectFromJSON)),
    };
}

export function ClaimQuestRewardResponseToJSON(json: any): ClaimQuestRewardResponse {
    return ClaimQuestRewardResponseToJSONTyped(json, false);
}

export function ClaimQuestRewardResponseToJSONTyped(value?: ClaimQuestRewardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rewards': ((value['rewards'] as Array<any>).map(RewardResponseObjectToJSON)),
    };
}

